import type React from 'react';

import { useGetStream } from '@vlabs/api/artemy/client';
import { StreamTargetsParameterItem } from '@vlabs/api/artemy/model';
import type { StreamId } from '@vlabs/api/artemy/model';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { StreamStatus as StreamStatusPill } from '../../../shared/ui/stream-statuses';

interface StreamStatusProps extends WithDataTestid {
  streamId: StreamId;
}

// Статус потока по streamId: самодостаточная сущность — сама запрашивает только статус
// (targets=['status']); повторный запрос осознанный. Рендер — презентационная пилюля из shared/ui.
function StreamStatus({
  streamId,
  'data-testid': dataTestId = undefined,
}: StreamStatusProps): React.JSX.Element | null {
  const { data } = useGetStream(streamId, {
    targets: [StreamTargetsParameterItem.status],
  });

  if (data?.status === undefined) return null;

  return (
    <StreamStatusPill
      status={data.status}
      testId={dataTestId}
      type="text"
    />
  );
}

export { StreamStatus };
